var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlashOn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.428,
    height: 20,
    viewBox: "0 0 11.428 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-flash",
    "data-name": "Icon ionic-ios-flash",
    d: "M17.077,10.069H12.248l2.339-8.341a.18.18,0,0,0-.321-.152l-8.2,10.751a.376.376,0,0,0,.281.6h4.829L8.838,21.267a.18.18,0,0,0,.321.152l8.2-10.747A.381.381,0,0,0,17.077,10.069Z",
    transform: "translate(-5.998 -1.497)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlashOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FlashOn.7271d4634e15184c354a09cc3099e937.svg";